module.exports = __webpack_public_path__ + "img/stock1.cbd83d6c.png";